'use client';

import { Image as CrystallizeImage } from '@crystallize/reactjs-components';
import { CustomModal } from '../custom-modal';
import { cn, TSingleDetailsProps } from 'types';

export const SingleDetails = (props: TSingleDetailsProps) => {
  const { open, onCloseClick, details, title, className, fallbackImgSrc } = props;

  return (
    <CustomModal
      open={open}
      onCloseClick={onCloseClick}
      className={cn('z-9 !absolute', className)}
      withoutOverlay
      autoCloseOnFocusOut
    >
      <div className="grid md:grid-cols-2 md:gap-8 gap-6 p-6">
        {props.img ? (
          <CrystallizeImage
            {...props?.img}
            loading="lazy"
            className="m-0 md:[&_img]:max-w-[18.5rem] w-full h-auto [&_img]:object-contain [&_img]:aspect-4/3"
          />
        ) : (
          <img src={fallbackImgSrc} width="312px" alt="Bilde mangler" className="aspect-4/3 object-contain" />
        )}
        <div
          className={cn({
            hidden: !details && !title,
          })}
        >
          <p className="text-[1.25rem]/[180%] font-extrabold mb-4">{title}</p>
          <div>{details}</div>
        </div>
      </div>
    </CustomModal>
  );
};
